export enum AddModuleStepEnum {
  HOME = 'home',
  DATA_REPRESENTATION = 'data_representation',
  OPTIONS = 'options',
}
